export enum postImportJourneySummary {
  POST_IMPORT_JOURNEY_SUMMARY_REQUEST = ' POST_IMPORT_JOURNEY_SUMMARY_REQUEST'
}
